import { camelCaseToTitle } from '../../../../../helpers/StringHelper';

export const getSupplyChainMaxScore = (maxScore) => {
  if (maxScore === 0) {
    return 1;
  }
  if (maxScore < 20) {
    return 1;
  } else if (maxScore < 40) {
    return 2;
  } else if (maxScore < 60) {
    return 3;
  } else if (maxScore < 80) {
    return 4;
  }
  return 5;
};

export const addVirtualPoints = ({
  startValue = 0, values, initValue, lastValue, startFromZero = true,
}) => {
  const items = [];
  if (startFromZero) {
    const incrVal = (lastValue - initValue) / values;
    for (let i = 0; i < values; i++) {
      items.push({
        date: `_${startValue}`,
        Score: 0 + (incrVal * i),
        dontShow: true,
      });
      startValue++;
    }
    return items;
  } else {
    const incrVal = (lastValue - initValue) / (values + 1);
    for (let i = 0; i < values; i++) {
      items.push({
        date: `_${startValue}`,
        Score: initValue + (incrVal * (i + 1)),
        dontShow: true,
      });
      startValue++;
    }
  }
  return items;
};

export const oneCase = ({ versions }) => {
  const items = []
  const item = versions[0];
  const before = addVirtualPoints({
    startValue: 0,
    values: 50,
    lastValue: item.Score || 0,
    initValue: item.Score || 0,
    startFromZero: false,
  });
  const after = addVirtualPoints({
    startValue: 50,
    values: 50,
    lastValue: item.Score || 0,
    initValue: item.Score || 0,
    startFromZero: false,
  });
  items.push(...before);
  items.push({
    Score: item.Score || 0,
    date: item.date,
  });
  items.push(...after);
  return items;
};

export const middleCase = ({ versions, value }) => {
  const items = [];
  const firstItem = versions[0];
  const before = addVirtualPoints({
    startValue: 0,
    values: value,
    lastValue: firstItem.Score || 0,
    initValue: firstItem.Score || 0,
    startFromZero: false,
  });
  items.push(...before);
  for (let i = 0; i < versions.length; i++) {
    const item = versions[i];
    items.push({
      Score: item.Score || 0,
      date: item.date,
    });
    let toPush = [];
    if (i === versions.length - 1) {
      toPush = addVirtualPoints({
        startValue: value + (i * value),
        values: value,
        lastValue: item.Score || 0,
        initValue: item.Score || 0,
        startFromZero: false,
      });
    } else {
      toPush = addVirtualPoints({
        startValue: value + (i * value),
        values: value,
        lastValue: versions[i + 1].Score || 0,
        initValue: item.Score || 0,
        startFromZero: false,
      });
    }
    items.push(...toPush);
  }
  return items;
};

export const filterData = (data = {}, selectOption) => {
  let all = [];
  let maxScore = 0;

  const _data = data[selectOption];

  if (!_data) {
    return { allData: all, maxScore };
  }

  Object.keys(_data).forEach((k) => {
    if (_data[k] > maxScore) {
      maxScore = _data[k];
    }
    all.push({ key: k, Score: _data[k], date: camelCaseToTitle(k) });
  });

  if (all.length) {
    switch (all.length) {
      case 1:
        all = oneCase({ versions: all });
        break;
      default:
        const value = Math.round(70 / all.length);
        all = middleCase({ versions: all, value: value <= 0 ? 0 : value });
    }
  }
  return { allData: all, maxScore };
};

export const getLineColor = (maxScore) => {
  switch (maxScore) {
    case 5:
      return '#B42318';
    case 4:
      return '#CC4426';
    case 3:
      return '#E7783A';
    case 2:
      return '#FFB546';
    case 1:
      return '#78C65D';
    default:
      return '#B42318';
  }
};

export const getYAxis = (type) => {
  if (type === 'SUPPLY_CHAIN_RISK') {
    return {
      tickMethod: () => [0, 20, 40, 60, 80, 100],
    };
  }

  return {
    tickMethod: () => [0, 1, 2, 3, 4, 5],
  };
};

export const getMaxScore = (type, maxScore) => {
  if (type === 'SUPPLY_CHAIN_RISK') {
    const _val = (maxScore || 0) / 20;
    return Math.ceil(_val) || 1;
  }

  return Math.ceil(maxScore) || 1;
};